export default __webpack_public_path__ + "static/media/植被覆盖度变化.74092b65.png";